import Purchases from 'react-native-purchases'

import type { PurchaseResult } from './useRevenueCatPurchaseResult'
import {
  hasActiveAccess,
  normalizeRevenueCatId,
} from '../services/entitlement-utils'

type CustomerInfo = Awaited<ReturnType<typeof Purchases.getCustomerInfo>>

export { normalizeRevenueCatId }

export function resolvePurchaseOwnershipMismatch({
  customerInfo,
  revenueCatId,
}: {
  customerInfo: CustomerInfo
  revenueCatId: string | null | undefined
}): Extract<PurchaseResult, { outcome: 'ownership_mismatch' }> | null {
  if (!hasActiveAccess(customerInfo)) {
    return null
  }

  const originalAppUserId = normalizeRevenueCatId(
    customerInfo.originalAppUserId,
  )
  const currentRevenueCatId = normalizeRevenueCatId(revenueCatId)

  if (
    originalAppUserId == null ||
    currentRevenueCatId == null ||
    originalAppUserId === currentRevenueCatId
  ) {
    return null
  }

  return {
    outcome: 'ownership_mismatch',
    originalAppUserId,
    currentRevenueCatId,
  }
}
